import { captureRemixErrorBoundaryError, withSentry } from "@sentry/remix";
import { Links, Meta, Outlet, Scripts, ScrollRestoration, useRouteError } from "@remix-run/react";
import type { LinksFunction } from "@remix-run/node";
import twitterCard from "~/assets/images/twitterCard.png";

import "./tailwind.css";
import Navigation from "./Components/Navigation";
import setSentryError from "./utils/setSentryError";

export const links: LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
  },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://order.xaman.app" />
        <meta property="og:title" content="Order your Xaman + Tangem card(s)" />
        <meta property="og:description" content="Unmatched security, effortless usability, and total control—Xaman Tangem Cards redefine self-custody for XRP and Xahau." />
        <meta property="og:image" content="https://xrpl-labs.com/static/tangem-v2/twittercard.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://order.xaman.app" />
        <meta name="twitter:title" content="Order your Xaman + Tangem card(s)" />
        <meta name="twitter:description" content="Unmatched security, effortless usability, and total control—Xaman Tangem Cards redefine self-custody for XRP and Xahau." />
        <meta name="twitter:image" content="https://xrpl-labs.com/static/tangem-v2/twittercard.png" />
        <meta name="twitter:creator" content="@XRPLLabs" />
        <Meta />
        <Links />
      </head>
      <body>
        <Navigation />
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  // setSentryError('GENERAL_ERROR', { error });
  captureRemixErrorBoundaryError(error);
  return <div>Something went wrong</div>;
};

function App() {
  return <Outlet />;
}

export default withSentry(App);